import type { FC } from 'react'

import { useNavigate, useParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import { EditSolidIcon } from '@dhl-ui/icons'
import { Body1, Body2, Box, Card, Grid, H6, IconButton } from '@dhl-ui/components'
import { links } from '~/AppRoutes'
import { useBillingUnit } from '~/modules/billingunits/hooks'

type Params = {
  id: string
}

export const BillingunitDetails: FC = () => {
  const { id } = useParams<Params>()
  const navigate = useNavigate()
  const { t } = useTranslation()
  const { billingUnit } = useBillingUnit(id)

  const onClickEdit = () => {
    id && navigate(links.billingUnitsEditLink(id))
  }

  return (
    <Card>
      <Card.Header
        title={t('admin.billingUnitsPage.titleText')}
        endNode={
          <IconButton aria-label="edit billingunits" onClick={onClickEdit}>
            <EditSolidIcon data-testid="edit-billingunits" />
          </IconButton>
        }
      />
      <Card.Content>
        <H6>{t('admin.billingUnitsPage.billingUnitsForm.account')}</H6>
        <Grid container direction="row">
          <Grid size={{ sm: 6, xs: 12 }}>
            <Box pt={2}>
              <Body2 variant="tertiary">{t('admin.billingUnitsPage.billingUnitsForm.identifier')}</Body2>
              <Body1>{billingUnit?.cccId}</Body1>
            </Box>
          </Grid>
        </Grid>
        <Grid container direction="row">
          <Grid size={{ sm: 6, xs: 12 }}>
            <Box pt={2}>
              <Body2 variant="tertiary">{t('admin.billingUnitsPage.billingUnitsForm.name')}</Body2>
              <Body1>{billingUnit?.name}</Body1>
            </Box>
          </Grid>
          <Grid size={{ sm: 6, xs: 12 }}>
            <Box pt={2}>
              <Body2 variant="tertiary">{t('admin.billingUnitsPage.billingUnitsForm.description')}</Body2>
              <Body1>{billingUnit?.description}</Body1>
            </Box>
          </Grid>
        </Grid>
        <Box pt={4}>
          <H6>{t('admin.billingUnitsPage.billingUnitsForm.labelCodeRange')}</H6>
          <Grid container direction="row">
            <Grid size={{ xs: 4 }}>
              <Box pt={2}>
                <Body2 variant="tertiary">{t('admin.billingUnitsPage.billingUnitsForm.trackerCodeMin')}</Body2>
                <Body1>{billingUnit?.trackerCodeMin || '-'}</Body1>
              </Box>
            </Grid>
            <Grid size={{ xs: 4 }}>
              <Box pt={2}>
                <Body2 variant="tertiary">{t('admin.billingUnitsPage.billingUnitsForm.trackerCodeMax')}</Body2>
                <Body1>{billingUnit?.trackerCodeMax || '-'}</Body1>
              </Box>
            </Grid>
            <Grid size={{ xs: 4 }}>
              <Box pt={2}>
                <Body2 variant="tertiary">{t('admin.billingUnitsPage.billingUnitsForm.trackerCodeLast')}</Body2>
                <Body1>{billingUnit?.trackerCodeLast || '-'}</Body1>
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Card.Content>
    </Card>
  )
}
